import { render, staticRenderFns } from "./verify-code.vue?vue&type=template&id=39ba7239&scoped=true"
import script from "./verify-code.vue?vue&type=script&lang=js"
export * from "./verify-code.vue?vue&type=script&lang=js"
import style0 from "./verify-code.vue?vue&type=style&index=0&id=39ba7239&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ba7239",
  null
  
)

export default component.exports